import { DataDispatchChannelEnum } from '../enums/data-dispatch-channel.enum';

/**
 * Dispatch request. The server chooses the file and the report.
 */
export class DataDispatchOptions {
  channel?: DataDispatchChannelEnum;
}
